import valueimage from "../../assets/values/value-img.png";
import Image from "../ui/Image";
import useHomeSection from '../../hooks/useHomeSection';
import { useTranslation } from "react-i18next";

const ValueCard = ({ value }) => {
  return (
    <div className="flex items-center gap-2">
      <div className="bg-secondary-tw rounded-full size-11 flex justify-center items-center relative">
        <Image src={value?.image} alt={value?.title}
          className="size-8" />
      </div>
      <p className="text-lg max-sm:text-sm">
        {value?.title}
      </p>
    </div>
  )
};

const ValuesSection = () => {
  const { data: values, error, isLoading } = useHomeSection({ sectionName: 'value' });
  const { t } = useTranslation();
  return (
    <div className="container">
      <section className="space-y-6">
        <div className="flex justify-center">
          <h1 className="services-header flex justify-center after:w-20">
            {t('home.our-manners')}
          </h1>
        </div>
        <div className="grid grid-cols-[45%_50%] gap-10 max-lg:grid-cols-1">
          <div className="relative w-full h-auto max-lg:w-full">
            <Image
              src={valueimage}
              alt={'value-img'}
              className="w-full h-full object-cover rounded-md"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            {(isLoading && !error) ?
              <>
                {
                  [...Array(6)].map((_, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className="size-11 rounded-full l-load"></div>
                      <div className="w-24 h-3 rounded-md l-load-dt"></div>
                    </div>
                  ))
                }
              </>
              :
              <>
                {
                  values?.map((value, i) => (
                    <ValueCard value={value} key={value?.id || i} />
                  ))
                }
              </>
            }
          </div>
        </div>
      </section>
    </div>
  );
};

export default ValuesSection;
